import type { Special } from "@/types";

export const specials: Special[] = [
  {
    id: "sci-fi-golden-age",
    title: "科幻黄金十年",
    subtitle: "当银幕开始畅想未来",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20retro%20science%20fiction%20collage%20of%20glowing%20planets%2C%20starships%20and%20neon%20city%20lights%20over%20a%20deep%20teal%20starfield%20with%20warm%20orange%20highlights%2C%20vintage%20film%20grain%20texture%2C%20artistic%20illustration%2C%20no%20text%20no%20words&width=1400&height=700&seq=sp-scifi-cover&orientation=landscape",
    intro:
      "80年代是科幻想象最奔放的十年。特效技术的进步让创作者终于能把脑海里的未来搬上银幕，而这些作品谈论的，始终是人的孤独、恐惧与渴望。",
    groups: [
      {
        id: "future-machines",
        name: "未来与机器",
        description: "当机器开始思考，人类开始怀疑自己。",
        movieIds: ["blade-runner-1982", "the-terminator-1984", "aliens-1986"],
      },
      {
        id: "time-and-wonder",
        name: "时间与奇想",
        description: "穿越时空、遇见奇迹，也遇见更温柔的自己。",
        movieIds: [
          "back-to-the-future-1985",
          "e-t-1982",
          "my-neighbor-totoro-1988",
        ],
      },
    ],
  },
  {
    id: "action-and-romance",
    title: "热血与心动",
    subtitle: "枪火之外，还有初恋",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20retro%20split%20scene%20of%20an%20action%20city%20with%20amber%20streetlights%20on%20one%20side%20and%20a%20warm%20sunset%20romantic%20park%20on%20the%20other%2C%20teal%20and%20orange%20palette%2C%20vintage%20film%20grain%20texture%2C%20artistic%20illustration%2C%20no%20text%20no%20words&width=1400&height=700&seq=sp-action-cover&orientation=landscape",
    intro:
      "80年代既能拍出让人脊背发凉的追逐与搏命，也能把少年的心事与成年人的犹豫拍得无比柔软。这一专题把两种极端情绪放在一起。",
    groups: [
      {
        id: "hard-action",
        name: "80年代动作片精选",
        description: "不用替身，不靠解释，行动就是最好的台词。",
        movieIds: [
          "die-hard-1988",
          "top-gun-1986",
          "raiders-of-the-lost-ark-1981",
          "a-better-tomorrow-1986",
        ],
      },
      {
        id: "youth-love",
        name: "经典爱情与青春",
        description: "关于相遇、误解，以及那句迟到太久的告白。",
        movieIds: [
          "when-harry-met-sally-1989",
          "the-breakfast-club-1985",
          "ferris-bueller-1986",
          "rain-man-1988",
        ],
      },
    ],
  },
];

export function getSpecialById(id: string): Special | undefined {
  return specials.find((s) => s.id === id);
}